import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

class CanonicalHelmet extends Component {
  render() {
    const { location, ogImage } = this.props;
    const canonicalUrl = `https://web.uat-akash-go.com${location.pathname}`;
    const defaultOgImage = "https://web.uat-akash-go.com/Json_images/AkashGo.png";

    return (
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:image" content={ogImage || defaultOgImage} />
      </Helmet>
    );
  }
}

// Export the component wrapped in withRouter
export default withRouter(CanonicalHelmet);